export default "__VITE_ASSET__B96o$Ak9__"